import { render } from "./ValueListForm.vue?vue&type=template&id=5aa872cc&ts=true"
import script from "./ValueListForm.vue?vue&type=script&lang=ts"
export * from "./ValueListForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__